import React from 'react';

import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { ApplicantEntityIndex } from '@funnels/types';
import { HelpTooltip } from '@funnels/ui-components';
import { datadogUtil } from '@funnels/utils';

import { AddressField } from '../../../Fields';

interface PostSettlementMailingAddressProps extends ApplicantEntityIndex {
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const PostSettlementMailingAddress = ({
  applicantIndex,
  isOptional,
  isDisabled,
}: PostSettlementMailingAddressProps) => (
  <AddressField
    label="Post-settlement mailing address"
    name={FIELD_PATHS.APPLICANT_POST_SETTLEMENT_ADDRESS_FORMATTED(applicantIndex)}
    path={FIELD_PATHS.APPLICANT_POST_SETTLEMENT_ADDRESS(applicantIndex)}
    className={PII_FIELD_MASKING_CLASS}
    isOptional={isOptional}
    isDisabled={isDisabled}
    onException={(e) => datadogUtil.addError(e)}
    labelAfter={
      <HelpTooltip content={'This is where lender communication will be sent post settlement.'} position="top" />
    }
  />
);
